export default __webpack_public_path__ + "static/media/mobile-hero.a39fd8b2.mp4";